import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/problem_selected.png';
import _imports_1 from '@/assets/more.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-46b36442"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "icon"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  })], -1);
});
var _hoisted_2 = {
  "class": "text"
};
var _hoisted_3 = {
  key: 0,
  src: _imports_1
};
import { useNavigation } from '@/common/util/navigation';
export default /*#__PURE__*/_defineComponent({
  props: {
    item: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    more: {
      type: Boolean,
      "default": true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNavigation = useNavigation(),
      toNext = _useNavigation.toNext;
    var toInfo = function toInfo() {
      if (!props.item.id) return;
      toNext("/qa/".concat(props.item.id));
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": "IndexCardItem",
        onClick: toInfo
      }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(__props.item.name), 1), __props.more ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true)])]);
    };
  }
});